// extracted by mini-css-extract-plugin
export default {"pillowsHint":"AllTimePillowHint_pillowsHint__bnbzC"};